/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

// components
import Breadcrumbs from '../../components/Breadcrumbs'
import BulkUsersUploadStatuses from './components/bulkUsersUploadStatuses'
import SearchBar from './components/searchBar'
import { Typography } from '@mui/material'

// constants
import {
  getBulkStatuses,
  resetBulkStatuses,
} from '../../store/reducers/uploadStatusSlice'

//styles
import styles from './BulkUsersUploadActivity.module.scss'

import { getUserId } from '../../helpers/user'
import { getRecentBulkUploadJobs } from '../../services/user'
import { selectBulkStatusesArray } from '../../store/selectors/uploadStatus'

function BulkUsersUploadActivity() {
  const [searchText, setSearchText] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const [recentBulkJobs, setRecentBulkJobs] = useState([]);
  const [recentJobCount, setrecentJobCount] = useState(0);
  const { t } = useTranslation()


  let jobsToDisplay = []

  const breadcrumbPath = [
    { label: 'audit-bulk-status-tab' },
  ]

  const bulkUserUploadStatuses = useSelector(selectBulkStatusesArray)
  if (searchText.length > 0 && bulkUserUploadStatuses?.jobOwner) {
    jobsToDisplay = [bulkUserUploadStatuses]
  }

  if (searchText.length === 0 && recentBulkJobs?.length > 0 && recentJobCount > 0) {
    jobsToDisplay = recentBulkJobs.map(j => j.jobStatus)
  }

  const dispatch = useDispatch()

  const getBulkUploadStatuses = async () => {
    setIsFetching(true)
    try {
      if (searchText) {
        await dispatch(getBulkStatuses({ fileName: searchText })).unwrap()
      }
    } catch (error) {
      dispatch(resetBulkStatuses())
      toast.error(`${error?.message ? error.message : t('no-records-found')}`)
    } finally {
      setIsFetching(false)
    }
  }

  useEffect(() => {
    if (searchText?.length < 2) {
      dispatch(resetBulkStatuses())
    }

  }, [searchText])

  useEffect(() => {
    const fetchMostRecentJobs = async () => {
      setIsFetching(true)
      try {
        const userId = getUserId()
        const recentBulkJobStatuses = await getRecentBulkUploadJobs(userId)
        setRecentBulkJobs(recentBulkJobStatuses?.data?.jobReports)
        setrecentJobCount(recentBulkJobStatuses?.data?.jobCount)
      } catch (error) {
        toast.error(`${error?.message ? error.message : t('error-cause-not-provided')}`)
      } finally {
        setIsFetching(false)
      }
    }
    fetchMostRecentJobs()
  }, [])

  return (
    <div style={{ height: '100vh' }}>
      <div className={styles.stickyHeader} style={{
        backgroundColor: '#F5F5F5',
        width: '98vw',
        padding: '20px',
      }}>
        <Breadcrumbs className={styles.stickyHeader} crumbs={breadcrumbPath} />        
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          getBulkUploadStatuses={getBulkUploadStatuses}
        />
      </div>
      {<BulkUsersUploadStatuses isFetching={isFetching} bulkUserUploadStatuses={jobsToDisplay} searchText={searchText} />}
    </div>
  )
}

export default BulkUsersUploadActivity
